<template>
    <v-container fluid>
      <v-card elevation="2">
        <v-card-title class="d-flex align-center tableheader white--text">
          <v-icon left color="white">mdi-account-group</v-icon>
          Employees
          <v-spacer/>
          <v-text-field
              v-model="search"
              label="Search (name / email / phone)"
              prepend-inner-icon="mdi-magnify"
              density="compact"
              variant="solo-filled"
              flat hide-details single-line
              class="me-4"
          />
          <v-btn color="primary" @click="openDialog(null)" v-if="authStore.canEdit">
            <v-icon left>mdi-plus</v-icon> Add Employee
          </v-btn>
          <!-- <ExportButtons entity="employees" filename="Employees" :exclude="['id','created_at','updated_at']"></ExportButtons> -->
          <ExportButtons entity="employees" filename="Employees" :headers="headers"></ExportButtons>
        </v-card-title>
  
        <v-data-table :items="filtered" :headers="headers" class="elevation-1">
          
          <template v-slot:[`item.status`]="{ item }">
            <v-chip :color="item.status === 'active' ? 'success' : 'error'" label small>
              {{ findStatusName(item.status) }}
            </v-chip>
          </template>

          <template v-slot:[`item.salary`]="{ value }">
            {{ formatCurrency(value) }}
          </template>

          <template v-slot:[`item.expected_pay_day`]="{ value }">
            {{ value }} {{ formatDaySuffix(value) }}
          </template>

          <template v-slot:[`item.actions`]="{ item }">

            <v-tooltip location="top" text="View Details">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" small class="me-1" @click="openViewDialog(item)" color="info">
                mdi-eye-outline
              </v-icon>
            </template>
            </v-tooltip>

            <v-tooltip location="top" text="Edit">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" small class="me-1" @click="openDialog(item)" color="secondary" v-if="authStore.isAdmin">
                mdi-pencil
              </v-icon>
            </template>
            </v-tooltip>
            
            <v-tooltip location="top" text="Delete">
            <template v-slot:activator="{ props }">
              <v-icon v-bind="props" small @click="deleteItemPrompt(item)" color="error" v-if="authStore.isAdmin">
                mdi-delete
              </v-icon>
            </template>
            </v-tooltip>

          </template>
          <template v-slot:[`no-data`]>
            <v-alert :value="true" color="info" icon="mdi-information-variant" class="ma-3">
              {{ tableLoading ? 'Fetching data...' : 'No employees available or match your search.' }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
  
      <!-- dialog -->
      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title>{{ form.id ? 'Edit' : 'Add' }} Employee</v-card-title>
          <v-form ref="employeeForm" v-model="isFormValid" @submit.prevent="save">
          <v-card-text>
            <v-text-field v-model="form.first_name" label="First Name*" variant="outlined" 
            :rules="[rules.required]"
            required/>
            <v-divider></v-divider>
            <v-text-field v-model="form.last_name" label="Last Name*" variant="outlined" 
            :rules="[rules.required]"
            required/>
            <v-divider></v-divider>
            <v-text-field v-model="form.email" label="Email" variant="outlined" />  

            <v-divider></v-divider>
            <v-text-field v-model="form.phone_number" label="Phone*" variant="outlined" 
            :rules="[rules.required]"
            required/>
            <v-divider></v-divider>
            <v-text-field v-model="form.job_title" label="Job Title*" variant="outlined" 
            :rules="[rules.required]"
            required/>
            <v-divider></v-divider>
            <v-text-field type="date" v-model="form.hire_date" label="Hire Date*" variant="outlined" 
            :rules="[rules.required]"
            required/>
            <v-divider></v-divider>
            <v-text-field v-model="form.salary" label="Salary*" variant="outlined" 
            :rules="[rules.required]"
            required/>
            <v-divider></v-divider>
            <v-text-field v-model="form.expected_pay_day" label="Expected Pay Day*" variant="outlined" 
            :rules="[rules.required]"
            required/>
            <v-divider></v-divider>
            <v-select
              :items="statuses"
              item-title="name"
              item-value="id"
              v-model="form.status"
              label="Status"
              variant="outlined" class="mb-2" :rules="[rules.required]"
            />
          </v-card-text>

          <v-card-actions>
            <v-spacer/>
            <v-btn text @click="dialog=false">Cancel</v-btn>
            <v-btn color="primary" variant="elevated" type="submit" :loading="dialogLoading" :disabled="!isFormValid">Save</v-btn>
            <!-- @click="save" -->
          </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-dialog v-model="viewDialog" max-width="800px" @update:modelValue="val => !val && closeViewDialog()">
      <v-card :loading="viewDialogLoading">
        <v-card-title class="tableheader white--text d-flex align-center">
          <!-- <v-icon left color="white" class="mr-2">mdi-truck-wrench</v-icon> -->
          <span class="text-h5">Employee Details: {{ viewItem?.first_name }} {{ viewItem?.last_name }}</span>
          <v-spacer></v-spacer>
          <!-- <v-btn icon="mdi-close" variant="text" color="white" @click="closeViewDialog"></v-btn> -->
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text v-if="viewItem" class="pt-4">
          <v-list lines="two" density="compact">
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">First Name:</div>
              </template>
              <v-list-item-text class="text-right pl-2">{{ viewItem.first_name }}</v-list-item-text>
            </v-list-item>
            <v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Last Name:</div>
              </template>
              <v-list-item-text class="text-right pl-2">{{ viewItem.last_name }}</v-list-item-text>
            </v-list-item>
            <v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Email:</div>
              </template>
              <v-list-item-text class="text-right pl-2">{{ viewItem.email }}</v-list-item-text>
            </v-list-item>
            <v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Phone Number:</div>
              </template>
              <v-list-item-text class="text-right pl-2">{{ viewItem.phone_number }}</v-list-item-text>
            </v-list-item>
            <v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Job Title:</div>
              </template>
              <v-list-item-text class="text-right pl-2">{{ viewItem.job_title }}</v-list-item-text>
            </v-list-item>
            <v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Hire Date:</div>
              </template>
              <v-list-item-text class="text-right pl-2">{{ formatDateForDisplay(viewItem.hire_date) }}</v-list-item-text>
            </v-list-item>
            <v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Salary:</div>
              </template>
              <v-list-item-text class="text-right pl-2">{{ viewItem.salary }}</v-list-item-text>
            </v-list-item>
            <v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Expected Pay Day:</div>
              </template>
              <v-list-item-text class="text-right pl-2">{{ viewItem.expected_pay_day }} {{ formatDaySuffix(viewItem.expected_pay_day) }}</v-list-item-text>
            </v-list-item>
            <v-divider inset></v-divider>
            <v-list-item>
              <template v-slot:prepend>
                <div class="font-weight-medium">Status:</div>
              </template>
              <v-list-item-text class="text-right pl-2">{{ findStatusName(viewItem.status) }}</v-list-item-text>
            </v-list-item>
            <v-divider inset></v-divider>
          </v-list>
        </v-card-text>
        <v-card-text v-else class="text-center py-5">
            <v-progress-circular indeterminate color="primary" class="mb-3"></v-progress-circular>
            <p>Loading employee details...</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="bg-grey-lighten-4 pa-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" variant="tonal" @click="closeViewDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <v-dialog v-model="deleteDialog" max-width="500px">
        <v-card :loading="dialogLoading">
          <v-card-title class="text-h5">Confirm Deletion</v-card-title>
          <v-card-text>Are you sure you want to delete this employee: {{ itemToDelete?.first_name }} {{ itemToDelete?.last_name }}?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue-darken-1" text @click="closeDeleteDialog" :disabled="dialogLoading">Cancel</v-btn>
            <v-btn color="red-darken-1" text @click="confirmDelete" :loading="dialogLoading">Delete</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="snackbar.timeout" bottom right>
        {{ snackbar.message }}
        <template v-slot:actions>
          <v-btn color="white" variant="text" @click="snackbar.show = false">Close</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </template>
  
  <script setup>
  import { ref, computed, onMounted, nextTick } from 'vue';
  import EmployeeService from '@/services/EmployeesService';
  import { useAuthStore } from '@/stores/auth'; 
  import { useSnackbar, formatDateForDisplay, formatCurrency, formatDaySuffix } from '@/services/genFunctions';
  import ExportButtons from '@/components/ExportButtons.vue';

  const { snackbar, showSnackbar } = useSnackbar();
  const authStore = useAuthStore();
  const employees  = ref([]);
  const search   = ref('');
  const dialog   = ref(false);
  const form     = ref({ id:null, first_name:'', last_name:'', email:'', phone_number:'', job_title:'', hire_date:'', salary:'', expected_pay_day:'', status:''});
  const deleteDialog = ref(false);
  const itemToDelete = ref(null);
  const dialogLoading = ref(false);
  const viewDialog = ref(false);
  const viewItem = ref(null);
  const viewDialogLoading = ref(false);
  const tableLoading = ref(true);
  const employeeForm = ref(null);
  const isFormValid = ref(false);

  const statuses = [
    { id: 'active', name: 'Active' },
    { id: 'inactive', name: 'Inactive' }
  ];

  const rules = {
    required: value => !!value || 'This field is required.',
  };

  const headers = [
    // { title:'ID', key:'id', sortable:false },
    { title:'First Name', key:'first_name' },
    { title:'Last Name', key:'last_name' },
    { title:'Email', key:'email' },
    { title:'Phone Number', key:'phone_number' },
    { title:'Job Title', key:'job_title' },
    { title:'Hire Date', key:'hire_date' },
    { title:'Salary', key:'salary' },
    { title:'Expected Pay Day', key:'expected_pay_day' },
    { title:'Status', key:'status' },
    { title:'Actions', key:'actions', sortable:false, width: '150px' }
  ];
  
  const load = async () => employees.value = await EmployeeService.getEmployees();
  
  onMounted(async () => {
    tableLoading.value = true;
    try {
      await load();
    } catch (error) {
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
          showSnackbar(error.response.data.error || 'You are not authorized to view employees.', 'error');
      } else {
          showSnackbar('Failed to load employees.', 'error');
      }
      console.error("Error fetching employees:", error);
      employees.value = [];
    } finally {
      tableLoading.value = false;
    }
  });
  
  const filtered = computed(() =>
    employees.value.filter(e =>
      (e.first_name+e.last_name+e.email+e.phone_number).toLowerCase().includes(search.value.toLowerCase())
    )
  );
  
  function openDialog(item) {
    form.value = item ? { ...item } : { id:null, first_name:'', last_name:'', email:'', phone_number:'', job_title:'', hire_date:'', salary:'', expected_pay_day:'', status:'' };
    dialog.value = true;
  }
  async function save() {
    if (!employeeForm.value) return;
    const { valid } = await employeeForm.value.validate();
    if (!valid) {
      showSnackbar('Please correct the form errors.', 'warning');
      return;
    }

    dialogLoading.value = true;
    const { id, ...data } = form.value;
    id ? await EmployeeService.updateEmployee(id, data)
       : await EmployeeService.createEmployee(data);
    dialog.value = false;
    await load();
    dialogLoading.value = false;
    showSnackbar('Employee saved successfully!', 'success');
  }

  const deleteItemPrompt = (item) => {
    itemToDelete.value = { ...item };
    deleteDialog.value = true;
  };

  const closeDeleteDialog = () => {
    deleteDialog.value = false;
    nextTick(() => itemToDelete.value = null);
    dialogLoading.value = false;
  };

  const confirmDelete = async () => {
    if (!itemToDelete.value?.id) return;
    dialogLoading.value = true;
    try {
        await EmployeeService.deleteEmployee(itemToDelete.value.id);
        employees.value = employees.value.filter(e => e.id !== itemToDelete.value.id);
        showSnackbar('Employee deleted successfully!', 'success');
        closeDeleteDialog();
    } catch (error) {
        const errorMsg = error.response?.data?.error || 'Could not delete employee.';
        showSnackbar(errorMsg, 'error', 6000);
        console.error("Error deleting employee:", error.response || error);
    } finally {
        dialogLoading.value = false;
    }
  };

  const openViewDialog = async (item) => {
    viewDialogLoading.value = true;
    viewDialog.value = true;
    viewItem.value = null; 
    try {
      const fullEmployeeData = await EmployeeService.getEmployee(item.id);
      viewItem.value = fullEmployeeData;
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Failed to load employee details.';
      showSnackbar(errorMsg, 'error');
      console.error("Error fetching employee details for view:", error);
      viewDialog.value = false; 
    } finally {
      viewDialogLoading.value = false;
    }
  };

  const closeViewDialog = () => {
    viewDialog.value = false;
    viewItem.value = null;
  };

  const findStatusName = (status) => {
    const statusObj = statuses.find(s => s.id === status);
    return statusObj ? statusObj.name : 'Unknown';
  };
  
  </script>
  